module.exports = __webpack_public_path__ + "static/media/onewatch-logo_6b92.png";